// object utils file

// swap keys and values
export const swap = (obj) =>
  Object.entries(obj).reduce(
    (acc, [key, value]) => ({ ...acc, [value]: key }),
    {}
  );
